import { KlusModel } from "@personeel/models/KlusModel";
import { useSelectedTimeStore } from "@shared/common/contexts/SelectedTime/useSelectedTimeStore";
import { Klus } from "./Klus";
import { Lopen } from "./Lopen";

interface IKlussen {
  klussen: KlusModel[];
  scale: number;
}

export function Klussen({ klussen, scale }: Readonly<IKlussen>) {
  const timeLineBegin = useSelectedTimeStore((state) => state.scenarioInterval?.start)!;
  const timeLineEnd = useSelectedTimeStore((state) => state.scenarioInterval?.end)!;

  return (
    <>
      {klussen.map((klus: KlusModel) => {
        return klus.klusSoort.startsWith("LOPEN_") ? (
          <Lopen
            key={klus.id}
            klus={klus}
            timeLineBegin={timeLineBegin}
            timeLineEnd={timeLineEnd}
            scale={scale}
          />
        ) : (
          <Klus
            key={klus.id}
            klus={klus}
            timeLineBegin={timeLineBegin}
            timeLineEnd={timeLineEnd}
            scale={scale}
          />
        );
      })}
    </>
  );
}
